module.exports = __webpack_public_path__ + "media/images/city/046-capitol-eab10d63887d6edf25b418f1728e612f.svg";